import React from 'react';
import PtrSpinner from '@components/PtrSpinner';
import usePullToRefresh from '@hooks/usePullToRefresh';
import { formatDateTimeWithAmPm } from '@helpers/date-time.helper';

interface PullToRefreshProps {
	onRefresh: () => Promise<void>;
	children: React.ReactNode;
	childHeight?: number;
	wrapperStyle?: string;
}

export default function PullToRefresh({ onRefresh, children, childHeight = 120, wrapperStyle = 'mt-6' }: PullToRefreshProps) {
	const { pullHeight, isRefreshing, pullRatio, handleTouchStart, handleTouchMove, handleTouchEnd, lastUpdated } = usePullToRefresh({
		onRefresh,
	});

	return (
		<div className='w-full h-full flex flex-col items-center' onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd}>
			<div
				className={`desktop:hidden flex justify-center items-center flex-col w-full absolute left-0 right-0 pointer-events-none ${wrapperStyle}`}
				style={{
					transition: isRefreshing ? 'none' : 'opacity 0.2s ease-out',
				}}>
				<div className='transition-opacity duration-200 ease-out' style={{ opacity: pullRatio }}>
					<PtrSpinner pullRatio={pullRatio} spinning={isRefreshing} />
				</div>
				{lastUpdated && (
					<div className='text-sm text-blue-grey mt-2 transition-opacity duration-200 ease-out' style={{ opacity: pullRatio }}>
						Last updated: {lastUpdated ? formatDateTimeWithAmPm(lastUpdated) : ''}
					</div>
				)}
			</div>
			<div
				className='w-full h-full transition-transform duration-200 ease-out flex flex-col items-center relative'
				style={{
					transform: `translateY(${pullHeight > childHeight ? childHeight : pullHeight}px)`,
					transition: isRefreshing ? 'none' : 'transform 0.2s ease-out',
				}}>
				{children}
			</div>
		</div>
	);
}
